<template>
  <c-flex-layout class="workspace-item">
    <template #left>
      <div :style="{ display: 'flex', alignItems: 'center' }">
        <c-avatar
          :user-name="workspace.workspace_name"
          :src="workspace.workspace_icon"
          size="60px"
        />
        <div :style="{ marginLeft: '2rem' }">
          <div :style="{ fontSize: $fontSizes[7], fontWeight: '500' }">
            {{ workspace.workspace_name }}
          </div>
          <div :style="{ color: $colors.grey.base }">
            Connected at {{ formatTime(workspace.connectedAt) }}
          </div>
        </div>
      </div>
    </template>
    <template #right>
      <c-dropdown>
        <c-button
          match-trigger-width
          icon="ellipsis"
          close-on-click
          fab
        />
        <template #content>
          <c-card
            :style="{ minWidth: '15rem' }"
            contains-list
          >
            <c-card-item
              title="Delete"
              icon="delete"
              @click="deleteWorkspace"
            />
          </c-card>
        </template>
      </c-dropdown>
    </template>
  </c-flex-layout>
</template>

<script>

import CAvatar from 'shared/components/CAvatar.vue';
import CButton from 'shared/components/CButton.vue';
import CCard from 'shared/components/CCard.vue';
import CCardItem from 'shared/components/CCardItem.vue';
import CDropdown from 'shared/components/CDropdown.vue';
import CFlexLayout from 'shared/components/CFlexLayout.vue';
import { USER_SERVICE } from 'shared/constants';
import { deleteDoc, deleteField, doc, getDoc, setDoc } from 'shared/services/firebase';
import { inject } from 'vue';

export default {
  name: 'WorkspaceItem',
  props: {
    workspace: {
      type: Object,
      required: true,
    },
  },
  components: { CAvatar, CDropdown, CFlexLayout, CButton, CCard, CCardItem },
  setup() {
    const userService = inject(USER_SERVICE);
    return { currentUser: userService.currentUser };
  },
  methods: {
    formatTime(date) {
      const d = new Date(date.seconds * 1000);
      return d.toDateString();
    },
    async deleteWorkspace() {
      await deleteDoc(doc(this.$db, 'users', this.currentUser.uid, 'workspaces', this.workspace.workspace_id));
      const userRef = doc(this.$db, 'users', this.currentUser.uid);
      const docSnap = await getDoc(userRef);
      if (docSnap.data().lastSelectedWorkspace === this.workspace.workspace_id) {
        await setDoc(userRef, { lastSelectedWorkspace: deleteField() }, { merge: true });
      }
    },
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>

</style>
